/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule, HttpErrorResponse } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
  NbTabsetModule,
  NbSpinnerModule,
  NbSelectModule,
} from '@nebular/theme';
import { NbAuthJWTToken, NbAuthModule, NbPasswordAuthStrategy } from '@nebular/auth';
import { AuthGuard } from './auth-guard.service';
import { environment } from 'environments/environment';
import { HttpModule } from '@angular/http';
import { ModaleComponent } from './generic/modale/modale.component';
import { ModalTemplateComponent } from './generic/modale/modal-template/modal-template.component';
import { CookiePolicyComponent } from './generic/cookie-policy/cookie-policy.component';
import { PrivacyPolicyComponent } from './generic/privacy-policy/privacy-policy.component';
import { ConfirmModaleComponent } from './generic/confirm-modal/confirm-modale.component';
import { LinkToComponent } from './generic/link-to/link-to.component';
import { LinkToForTableComponent } from './generic/link-to-for-table/link-to-for-table.component';
import { RoutingState } from './generic/routing-state';
import { NbDateFnsDateModule } from '@nebular/date-fns';
import { NbBadgeModule } from '@nebular/theme';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { QuestionarioComponent } from './generic/questionario/questionario.component';
import { Ng2CompleterModule } from 'ng2-completer';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxEchartsModule } from 'ngx-echarts';
import { QuestionarioUnoTreComponent } from './generic/questionario-uno-tre/questionario-uno-tre.component';
import { NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [AppComponent, CookiePolicyComponent, PrivacyPolicyComponent, ConfirmModaleComponent, LinkToComponent, LinkToForTableComponent, QuestionarioComponent, QuestionarioUnoTreComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    Ng2SmartTableModule,
    Ng2CompleterModule,
    ReactiveFormsModule,
    FormsModule,
    NgxEchartsModule,
    HttpClientModule,
    HttpModule,
    AppRoutingModule,
    NbSelectModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NgbTimepickerModule.forRoot(),
    NbDateFnsDateModule.forRoot({ format: 'dd/MM/yyyy' }),
    NbDateFnsDateModule.forChild({ format: 'dd/MM/yyyy' }),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbBadgeModule,
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    NbAuthModule.forRoot({
      strategies: [
        NbPasswordAuthStrategy.setup({

          name: 'email',
          token: {
            class: NbAuthJWTToken,
            key: 'jwtToken', // this parameter tells where to look for the token
          },
          baseEndpoint: environment.APIendpoint,
          login: {
             endpoint: '/ApplicativiRest/rest/users/login',
             method: 'post',
             redirect: {
               success: 'pages/main-apps',
               failure: null
             },
             requireValidToken: true,
             defaultErrors: ['Username/password errate. Si prega di riprovare.'],
             defaultMessages: ['Accesso effettuato con successo.'],
          },
          logout: {
            endpoint: '',
          },
          errors: {
            getter: (module, res, options) => {
              return res.status==999 ? res.message : options[module].defaultErrors;
            },
          }
          
        }),
      ],
      forms: {},
    }), 
  ],
  bootstrap: [AppComponent],
  providers: [
    AuthGuard,
    /* { provide: HTTP_INTERCEPTORS, useClass: HttpConfigInterceptor, multi: true } */
    RoutingState
  ],
  entryComponents: [
    ModaleComponent,
    ModalTemplateComponent,
    ConfirmModaleComponent,
    LinkToComponent,
    LinkToForTableComponent
  ]
})
export class AppModule {
}
